enum Permission {
  AVAILABILITY_CONSTRAINTS_DELETE = 'availability-constraints:delete',
  AVAILABILITY_CONSTRAINTS_WRITE = 'availability-constraints:write',
}

export { Permission }
